import { render, staticRenderFns } from "./FirstAidInfo.vue?vue&type=template&id=2c593ba1&scoped=true&"
import script from "./FirstAidInfo.vue.js?vue&type=script&lang=js&"
export * from "./FirstAidInfo.vue.js?vue&type=script&lang=js&"
import style0 from "./FirstAidInfo.vue?vue&type=style&index=0&id=2c593ba1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c593ba1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDatePicker,VForm,VMenu,VRadio,VRadioGroup,VRow,VTextField})
